export const localPermissionLabels = {
  power: 'Power',
  operatingMode: 'Operating mode',
  temperature: 'Temperature',
  fanSpeed: 'Fan speed',
  louvre: 'Louvre',
  filterReset: 'Filter reset',
  timer: 'Timer',
} as const;
export interface LocalPermissionsSnapshot {
  value: Record<string, string>;
  canEdit: boolean;
  pending: boolean;
  observedAt?: number | null;
}
export const knownPermission = (value: unknown) =>
  value === 'Permitted' || value === 'Prohibited';
export function permissionValues(
  value?: Record<string, string> | null,
): Record<string, string> {
  return Object.fromEntries(
    Object.keys(localPermissionLabels).map((key) => [
      key,
      ['Permitted', 'Prohibited', 'Unsupported'].includes(value?.[key] ?? '')
        ? value![key]
        : 'Unknown',
    ]),
  );
}

export function visibleLocalPermissions(value?: Record<string, string> | null) {
  const reported = permissionValues(value);
  return Object.entries(localPermissionLabels)
    .map(([field, label]) => ({ field, label, state: reported[field] }))
    .filter(({ state }) => state !== 'Unsupported');
}
